export default function initNewSearch() {
    const searchBar = document.querySelector('.search-bar');
    const header = document.querySelector('.nm-header');
    const input = document.querySelector('.search-bar__input');
    const searchBtn = document.querySelector('.nm-header__actions-link--search');
    if (header && searchBtn && searchBar && input) {
        searchBtn.addEventListener('click', () => {
            header.classList.add('search-opened');
            input.focus();

            document.addEventListener('click', (e) => {
                if (e.target.closest('.nm-header')) return
                header.classList.remove('search-opened');
            })
        })


    }


}



// WEBPACK FOOTER //
// ./src/js/newSearch.js